import { WGLBuffer, WGLProgram, WGLTexture } from "autumn-wgl";
const polyline_vertex_src = `uniform mat4 u_matrix;
uniform int u_offset;

attribute vec2 a_pos;
attribute float a_min_zoom;
attribute vec2 a_extrusion;
attribute vec2 a_offset;
attribute vec2 a_tex_coord;
uniform lowp float u_offset_scale;
uniform lowp float u_map_aspect;
uniform lowp float u_zoom;
uniform lowp float u_line_width;
uniform highp float u_map_bearing;


varying highp vec2 v_tex_coord;

mat4 scalingMatrix(float x_scale, float y_scale, float z_scale) {
    return mat4(x_scale, 0.0,     0.0,     0.0,
                0.0,     y_scale, 0.0,     0.0,
                0.0,     0.0,     z_scale, 0.0,
                0.0,     0.0,     0.0,     1.0);
}

mat4 rotationZMatrix(float angle) {
    float s = sin(angle);
    float c = cos(angle);

    return mat4( c,  s,  0., 0.,
                -s,  c,  0., 0.,
                    0., 0., 1., 0.,
                    0., 0., 0., 1.);
}

mat4 rotationXMatrix(float angle) {
    float s = sin(angle);
    float c = cos(angle);

    return mat4( 1.,  0., 0., 0.,
                    0.,  c,  s,  0.,
                    0., -s,  c,  0.,
                    0.,  0., 0., 1.);
}

void main() {
    float globe_width = 1.;
    vec2 globe_offset = vec2(globe_width * float(u_offset), 0.);

    vec4 center_pos = u_matrix * vec4(a_pos.xy + globe_offset, 0.0, 1.0);
    vec4 offset = vec4(0.0, 0.0, 0.0, 0.0);
    
    if (u_zoom >= a_min_zoom) {
        vec2 offset_2d = a_offset + u_line_width * a_extrusion;

        mat4 rotation_matrix = rotationZMatrix(radians(u_map_bearing));
        mat4 map_stretch_matrix = scalingMatrix(u_offset_scale, u_offset_scale / u_map_aspect, 1.);
        offset = map_stretch_matrix * rotation_matrix * vec4(offset_2d, 0., 0.);
    }

    gl_Position = center_pos + offset;
    v_tex_coord = a_tex_coord;
}`
const polyline_fragment_src = `varying highp vec2 v_tex_coord;

uniform sampler2D u_sampler;

void main() {
    if (v_tex_coord.x > 1.0) {
        discard;
    }

    lowp vec4 tex_color = texture2D(u_sampler, v_tex_coord);
    gl_FragColor = tex_color;
}`
class PolylineCollection {
    constructor(gl, polyline, tex_image, line_width, offset_scale) {
        this.width = line_width;
        this.scale = offset_scale;
        this.program = new WGLProgram(gl, polyline_vertex_src, polyline_fragment_src);
        this.origin = new WGLBuffer(gl, polyline['origin'], 2, gl.TRIANGLE_STRIP);
        this.offset = new WGLBuffer(gl, polyline['verts'], 2, gl.TRIANGLE_STRIP);
        this.extrusion = new WGLBuffer(gl, polyline['extrusion'], 2, gl.TRIANGLE_STRIP);
        this.min_zoom = new WGLBuffer(gl, polyline['zoom'], 1, gl.TRIANGLE_STRIP);
        this.texture = new WGLTexture(gl, tex_image);
        this.texcoords = new WGLBuffer(gl, polyline['texcoords'], 2, gl.TRIANGLE_STRIP);
    }
    render(gl, matrix, [map_width, map_height], map_zoom, map_bearing, map_pitch) {
        if (matrix instanceof Float32Array)
            matrix = [...matrix];
        this.program.use({ 'a_pos': this.origin, 'a_offset': this.offset, 'a_extrusion': this.extrusion, 'a_min_zoom': this.min_zoom, 'a_tex_coord': this.texcoords }, { 'u_offset_scale': this.scale * (map_height / map_width), 'u_line_width': this.width, 'u_matrix': matrix,
            'u_map_aspect': map_height / map_width, 'u_zoom': map_zoom, 'u_map_bearing': map_bearing, 'u_offset': 0 }, { 'u_sampler': this.texture });
        gl.enable(gl.BLEND);
        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
        this.program.draw();
        this.program.setUniforms({ 'u_offset': -2 });
        this.program.draw();
        this.program.setUniforms({ 'u_offset': -1 });
        this.program.draw();
        this.program.setUniforms({ 'u_offset': 1 });
        this.program.draw();
    }
}
export { PolylineCollection };
